/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import POSITION_ANALYSE_ACTION_TYPES, {
  PositionAnalyseActionTypes,
} from 'actionTypes/positionAnalyse';
import { API_STATUS } from 'constants/enums';
import { PositionAnalyticsState } from 'types/positionAnalyse';

export const initialState: PositionAnalyticsState = {
  positions: [],
  openModal: false,
  orders: {},
  pnlTab: {
    selectedTargetPrice: 0,
    selectedTargetDate: 0,
    selectedTargetDateIndex: 0,
    selectedRows: [],
    // Added this for getting the selected target price which has data
    // if we use selectedTargetPrice it updates based on UI interactions
    // so before we have the updated data for the selectedTargetPrice in the UI
    // it shows fallback values (ex: pnl tab - est price column- showing zero for changed target price on api call)
    lastResolvedTargetPrice: 0,
  },
  positionAnalytics: {
    data: null,
    apiStatus: API_STATUS.INITIAL,
    errorMessage: null,
    isAnalyticsApiRefetching: false,
  },
  isPositionAnalyseLoading: false,
  initiallySelectedPositionIds: [],
};

const { POSITION_ANALYTICS_PNL_TAB_LAST_RESOLVED_TARGET_PRICE } =
  PositionAnalyseActionTypes;

const positionAnalyseReducer = produce((draft, action) => {
  switch (action.type) {
    case POSITION_ANALYSE_ACTION_TYPES[PositionAnalyseActionTypes.POSITION_ANALYTICS]
      .LOAD: {
      draft.positionAnalytics.apiStatus = API_STATUS.LOADING;
      draft.positionAnalytics.isAnalyticsApiRefetching =
        action.options.isAnalyticsApiRefetching;
      break;
    }
    case POSITION_ANALYSE_ACTION_TYPES[PositionAnalyseActionTypes.POSITION_ANALYTICS]
      .SUCCESS: {
      draft.positionAnalytics.apiStatus = API_STATUS.SUCCESS;
      draft.positionAnalytics.data = action.result.result;
      draft.positionAnalytics.isAnalyticsApiRefetching = false;
      draft.isPositionAnalyseLoading = false;
      draft.pnlTab.lastResolvedTargetPrice = action.options.requestedTargetPrice;
      break;
    }
    case POSITION_ANALYSE_ACTION_TYPES[PositionAnalyseActionTypes.POSITION_ANALYTICS]
      .FAIL: {
      draft.positionAnalytics.apiStatus = API_STATUS.ERROR;
      // we are not showing the error message  instead fallback message is shown
      draft.positionAnalytics.errorMessage = null;
      draft.positionAnalytics.isAnalyticsApiRefetching = false;
      draft.isPositionAnalyseLoading = false;
      break;
    }
    case PositionAnalyseActionTypes.POSITION_ANALYSE_LOADING: {
      draft.isPositionAnalyseLoading = action.payload;
      break;
    }
    case PositionAnalyseActionTypes.SET_POSITIONS: {
      draft.positions = action.payload;
      break;
    }
    case PositionAnalyseActionTypes.UPDATE_MODAL_STATE: {
      draft.openModal = action.payload;
      break;
    }
    case PositionAnalyseActionTypes.ADD_PRODUCT_TO_ANALYZE: {
      draft.orders[action.payload.product_id] = {
        ...action.payload,
        time_in_force: 'gtc',
      };
      break;
    }
    case PositionAnalyseActionTypes.REMOVE_ALL_PRODUCT_FROM_ANALYZE: {
      draft.orders = {};
      break;
    }
    case PositionAnalyseActionTypes.POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_PRICE: {
      draft.pnlTab.selectedTargetPrice = action.payload;
      break;
    }
    case PositionAnalyseActionTypes.POSITION_ANALYTICS_PNL_TAB_SELECTED_TARGET_DATE: {
      draft.pnlTab.selectedTargetDate = action.payload.selectedPnlTableTargetDate;
      draft.pnlTab.selectedTargetDateIndex =
        action.payload.selectedPnlTableTargetDateIndex;
      break;
    }
    case PositionAnalyseActionTypes.POSITION_ANALYZE_PNL_TABLE_TAB_SELECTED_ROWS: {
      draft.pnlTab.selectedRows = action.payload.selectedRowIds;
      draft.pnlTab.selectedTargetDate = action.payload.selectedTargetDate;
      draft.pnlTab.selectedTargetDateIndex = action.payload.targetDateMax;
      break;
    }
    case POSITION_ANALYTICS_PNL_TAB_LAST_RESOLVED_TARGET_PRICE: {
      draft.pnlTab.lastResolvedTargetPrice = action.payload;
      break;
    }
    case PositionAnalyseActionTypes.POSITION_ANALYTICS_INITIALLY_SELECTED_POSITION_IDS: {
      draft.initiallySelectedPositionIds = action.payload;
      break;
    }
    case PositionAnalyseActionTypes.RESET_POSITION_ANALYTICS: {
      return initialState;
    }
    default:
      break;
  }
  return undefined;
}, initialState);

export default positionAnalyseReducer;
